import lightGallery from "lightgallery";
import lgZoom from "lightgallery/plugins/zoom";
import lgThumbnail from "lightgallery/plugins/thumbnail";

import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(".lightgallery-grid:not([data-lg-wired])")
    .forEach((galleryElement) => {
      galleryElement.setAttribute("data-lg-wired", "");
      lightGallery(galleryElement, {
        licenseKey: '0000-0000-000-0000',
        plugins: [lgZoom, lgThumbnail],
        speed: 500,
        thumbnail: true,
        selector: ".lightgallery__item",
      });
    });
});
